export const CHART_DEFAULT_FAMILY_FONT = 'SpoqaHanSans';
